/* ms-home.js - Msofas homepage v3
   Hero slideshow, per-word headline reveal, chapter fades, count-up.
   Re-runs on shopify:section:load so the theme editor stays live. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  var cio = null;

  function splitWords(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-aw]:not([data-aw-done])'), function (h) {
      h.setAttribute('data-aw-done', '1');
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'aw-word';
        s.textContent = w;
        s.style.transitionDelay = i * 70 + 'ms';
        h.appendChild(s);
        if (i !== words.length - 1) { h.appendChild(document.createTextNode(' ')); }
      });
    });
  }

  function playHeroIntro(root) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(
          root.querySelectorAll('.aw, .hero-media, .hero-draw, .hero-late'),
          function (el) { el.classList.add('in'); }
        );
      });
    });
  }

  function initSlideshow(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('.hslide'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.hdot'));
    var caps = Array.prototype.slice.call(section.querySelectorAll('.hcap'));
    if (slides.length < 2) { return; }
    var SLIDE_MS = parseInt(section.getAttribute('data-interval'), 10) || 6400;
    var idx = 0;
    var timer = null;

    function show(i) {
      idx = i;
      slides.forEach(function (el, k) { el.classList.toggle('on', k === i); });
      caps.forEach(function (el, k) { el.classList.toggle('on', k === i); });
      dots.forEach(function (el, k) {
        el.classList.remove('on');
        if (k === i) { void el.offsetWidth; el.classList.add('on'); }
      });
    }
    function next() { show((idx + 1) % slides.length); }
    function play() { if (!reduced && !timer) { timer = setInterval(next, SLIDE_MS); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); stop(); play(); });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });
    play();
  }

  function observeFades(root) {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
    }
    Array.prototype.forEach.call(root.querySelectorAll('.fade:not(.in)'), function (el) { io.observe(el); });
  }

  function observeCounters(root) {
    if (!cio) {
      cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          var el = e.target;
          cio.unobserve(el);
          var target = parseInt((el.getAttribute('data-count') || '').replace(/[^0-9]/g, ''), 10);
          if (isNaN(target)) { return; }
          if (reduced) { el.textContent = target.toLocaleString('en-GB'); return; }
          var start = null;
          var dur = 1500;
          function step(ts) {
            if (start === null) { start = ts; }
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.floor(target * eased).toLocaleString('en-GB');
            if (p < 1) { requestAnimationFrame(step); }
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.6 });
    }
    Array.prototype.forEach.call(root.querySelectorAll('.cu'), function (el) { cio.observe(el); });
  }

  function init(root) {
    document.documentElement.classList.add('ms-js');
    splitWords(root);
    observeFades(root);
    observeCounters(root);
    Array.prototype.forEach.call(root.querySelectorAll('.ms-hero'), function (hero) {
      initSlideshow(hero);
      playHeroIntro(hero);
    });
    if (root.classList && root.classList.contains('ms-hero')) {
      initSlideshow(root);
      playHeroIntro(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
